import { LabelledDateRange } from '@teetsh/app/src/types/zone';
import { getCalendarWeeksBetween } from '@teetsh/app/src/utils/time/getCalendarWeeksBetween';
import { isDuringWeekend } from '@teetsh/app/src/utils/time/isDuringWeekend';

export function getWeeksOfPeriode(
  from: Date,
  to: Date,
  buildLabel: (n: number) => string,
  sundayStart: boolean = false,
): LabelledDateRange[] {
  const allWeeks = getCalendarWeeksBetween(from, to, sundayStart);
  const scholarWeeks = allWeeks
    .filter(w => !isDuringWeekend(w.from, sundayStart)) // keep same logic as getScholarWeeksBetween : ignore week if it starts on a weekend day
    .map((w, index) => ({
      id: `week-${index + 1}`,
      label: buildLabel(index + 1),
      from: w.from,
      to: w.to,
    }));
  return scholarWeeks;
}
